import PspRequestGet from "./Get"
import PspRequestDetails from "./Details"

export {
    PspRequestGet,
    PspRequestDetails
}